import React, { useState, useEffect } from "react";

const ImgComponent = ({ image, classNames, altText, onErrorFn }) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = image;
    img.onerror = () => {
      if (onErrorFn) onErrorFn();
      setImgError(true);
    };
  }, [image]);

  return (
    <img
      className={`${classNames || ""} ${imgError ? "error" : ""}`}
      src={!imgError ? image : "/img/new-icons/broken-img.svg"}
      alt={altText}
      loading="lazy"
    />
  );
};
export default ImgComponent;
